module.exports = __webpack_public_path__ + "static/23-slideshow-8b72d33b2e1c207bafe3e392af5a2db0.jpg";